import React, { useEffect, useState } from 'react';
import { Check, Shield, CreditCard, Download, Star, ArrowRight, AlertTriangle, BookOpen, Scale, Gavel, Users, Globe, FileText, ChevronDown } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function SalesPage() {
  const mainProductImage = 'https://cdn.magicpatterns.com/uploads/v1X8bUs9xVv463diWmzNLe/CONJUNTO_DE_MOCKUPS_DERECHO.png';
  const bonus1Image = 'https://cdn.magicpatterns.com/uploads/8YViaSGQYBcmgFwwLmtPTA/bonus_1_(2).png';
  const bonus2Image = 'https://cdn.magicpatterns.com/uploads/f92t2HZ3ULEJgRYD7U9p1v/bonus_2_(2).png';
  const upsellImage = 'https://cdn.magicpatterns.com/uploads/g88my5ADUdP5T3BBdy8Xxr/upsell_derecho_.png';
  const MAIN_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50917997904178:1';
  const UPSELL_CHECKOUT_URL = 'https://pagos.docentesfelices.online/cart/50918002098482:1';
  const scrollToCheckout = () => {
    window.location.href = MAIN_CHECKOUT_URL;
  };
  const scrollToOffer = () => {
    const el = document.getElementById('oferta');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-black font-sans text-white" data-id="element-19">
      <MetaPixel data-id="element-20" />
      <CountdownTimer data-id="element-21" />
      <SocialProofPopup data-id="element-22" />

      {/* HERO SECTION - DARK THEME */}
      <header className="bg-black pt-6 pb-8 px-4 sm:px-6 lg:px-8 text-center" data-id="element-23">
        <div className="max-w-4xl mx-auto" data-id="element-24">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight mb-4" data-id="element-25">
            Todo tu año de Derecho{' '}
            <span className="text-green-500 italic" data-id="element-26">resuelto.</span>
          </h1>

          <div className="mb-3 flex justify-center" data-id="element-27">
            <img src={mainProductImage} alt="Mega Pack Derecho Listo Bundle" className="w-full max-w-2xl drop-shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCheckout} data-id="element-28" />
          </div>

          <p className="text-green-500 font-bold text-xl sm:text-2xl italic mb-3" data-id="element-29">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-gray-300 text-lg sm:text-xl mb-4 max-w-2xl mx-auto" data-id="element-30">
            El sistema que usan docentes de Derecho de secundaria en Argentina
            para planificar{' '}
            <span className="font-bold text-white underline decoration-green-500 decoration-2 underline-offset-4" data-id="element-31">
              todo el año en una tarde
            </span>
          </p>

          <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-4 text-sm font-bold text-gray-300 mb-4" data-id="element-32">
            <span className="flex items-center gap-1" data-id="element-33">
              <FileText size={16} className="text-green-500" data-id="element-34" /> 100% PDF
            </span>
            <span className="text-gray-600 hidden sm:inline" data-id="element-35">•</span>
            <span className="flex items-center gap-1" data-id="element-36">
              <Download size={16} className="text-green-500" data-id="element-37" /> Acceso inmediato
            </span>
            <span className="text-gray-600 hidden sm:inline" data-id="element-38">•</span>
            <span className="flex items-center gap-1" data-id="element-39">
              <BookOpen size={16} className="text-gray-400" data-id="element-40" /> Currículo
              argentino
            </span>
          </div>

          <div className="mt-4" data-id="element-41">
            <button onClick={scrollToOffer} className="w-full sm:w-auto bg-green-500 hover:bg-green-400 text-white text-lg sm:text-xl font-black py-4 px-8 rounded-lg shadow-[0_4px_0_rgb(22,163,74)] active:shadow-none active:translate-y-1 transition-all flex items-center justify-center gap-2 mx-auto" data-id="element-42">
              → QUIERO MI KIT COMPLETO AHORA
            </button>

            <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-4 mt-3 text-xs text-gray-400 font-medium" data-id="element-43">
              <span className="flex items-center gap-1" data-id="element-44">
                <Shield size={14} className="text-green-500" data-id="element-45" /> Garantía 7 días
              </span>
              <span className="text-gray-600 hidden sm:inline" data-id="element-46">•</span>
              <span className="flex items-center gap-1" data-id="element-47">
                <Shield size={14} className="text-green-500" data-id="element-48" /> Pago 100% seguro
              </span>
              <span className="text-gray-600 hidden sm:inline" data-id="element-49">•</span>
              <span className="flex items-center gap-1" data-id="element-50">
                <CreditCard size={14} className="text-green-500" data-id="element-51" /> Mercado Pago
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* PROBLEM AWARENESS - RED BORDERS */}
      <section className="py-8 px-4 bg-black border-t border-gray-800" data-id="element-52">
        <div className="max-w-3xl mx-auto" data-id="element-53">
          <h2 className="text-2xl sm:text-3xl font-black text-center text-white mb-5" data-id="element-54">
            Si sos docente de Derecho, esto te va a sonar familiar...
          </h2>

          <div className="space-y-2" data-id="element-55">
            {['Llegás del colegio agotado/a y todavía tenés que planificar.', 'Buscás actividades sobre Constitución, Derecho Penal, Civil, Laboral... y no encontrás nada organizado.', 'Armás todo desde cero: secuencias, actividades, evaluaciones.', 'Sentís que la materia queda en pura teoría y no sabés cómo hacerla práctica.', 'Te frustra no tener un sistema claro para todo el año.'].map((text, i) => <div key={i} className="bg-gray-900 border border-gray-800 border-l-4 border-l-red-500 p-3 rounded-r-lg" data-id="element-56">
                <p className="text-gray-200 font-medium text-base" data-id="element-57">{text}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* THE SOLUTION */}
      <section className="py-8 px-4 bg-black border-t border-gray-800" data-id="element-58">
        <div className="max-w-4xl mx-auto text-center mb-6" data-id="element-59">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-2" data-id="element-60">
            La solución:{' '}
            <span className="text-green-400" data-id="element-61">MEGA PACK DERECHO LISTO</span>
          </h2>
          <p className="text-lg text-gray-400" data-id="element-62">
            Un sistema profesional de enseñanza del Derecho diseñado
            específicamente para secundaria.
          </p>
        </div>

        {/* MODULES ACCORDION */}
        <div className="max-w-3xl mx-auto space-y-2" data-id="element-63">
          {[{
          title: '📘 TOMO I – FUNDAMENTOS DEL DERECHO',
          icon: <Scale size={22} data-id="element-64" />,
          bgColor: 'bg-blue-500/20',
          textColor: 'text-blue-400',
          borderColor: 'border-blue-500/40',
          activeBg: 'bg-blue-500/10',
          note: '💡 Incluye actividades, debates, mapas conceptuales y casos prácticos',
          topics: ['Qué es el Derecho y para qué sirve', 'Derecho objetivo y subjetivo', 'Norma jurídica: estructura y características', 'Diferencia entre norma jurídica, moral y social', 'Fuentes del Derecho: ley, costumbre, doctrina y jurisprudencia', 'Principios generales del Derecho', 'Interpretación jurídica (cómo se aplica la ley)', 'Sistema jurídico y coherencia normativa', 'Pirámide de Kelsen y jerarquía normativa']
        }, {
          title: '📗 TOMO II – DERECHO CONSTITUCIONAL Y ESTADO',
          icon: <BookOpen size={22} data-id="element-65" />,
          bgColor: 'bg-emerald-500/20',
          textColor: 'text-emerald-400',
          borderColor: 'border-emerald-500/40',
          activeBg: 'bg-emerald-500/10',
          note: '💡 Incluye análisis de casos, simulaciones y actividades de aplicación',
          topics: ['Constitución Nacional Argentina (explicada paso a paso)', 'Supremacía constitucional', 'División de poderes (Ejecutivo, Legislativo y Judicial)', 'Federalismo argentino', 'Forma de gobierno republicana', 'Control de constitucionalidad', 'Reforma constitucional', 'Funcionamiento del Estado']
        }, {
          title: '📙 TOMO III – DERECHOS HUMANOS Y GARANTÍAS',
          icon: <Globe size={22} data-id="element-66" />,
          bgColor: 'bg-amber-500/20',
          textColor: 'text-amber-400',
          borderColor: 'border-amber-500/40',
          activeBg: 'bg-amber-500/10',
          note: '💡 Incluye casos reales, debates y actividades de pensamiento crítico',
          topics: ['Derechos fundamentales', 'Derechos civiles, políticos y sociales', 'Evolución histórica de los derechos humanos', 'Tratados internacionales', 'Sistema interamericano de derechos humanos', 'Amparo, habeas corpus y habeas data', 'Protección de derechos en la actualidad']
        }, {
          title: '📕 TOMO IV – DERECHO CIVIL Y CONTRATOS',
          icon: <Users size={22} data-id="element-67" />,
          bgColor: 'bg-red-500/20',
          textColor: 'text-red-400',
          borderColor: 'border-red-500/40',
          activeBg: 'bg-red-500/10',
          note: '💡 Incluye análisis de contratos reales y resolución de casos',
          topics: ['Persona humana y persona jurídica', 'Atributos de la persona', 'Capacidad jurídica', 'Hechos y actos jurídicos', 'Vicios de la voluntad', 'Contratos: elementos y tipos', 'Responsabilidad civil', 'Situaciones reales aplicadas a la vida cotidiana']
        }, {
          title: '📘 TOMO V – DERECHO LABORAL Y COMERCIAL',
          icon: <BriefcaseIcon data-id="element-68" />,
          bgColor: 'bg-orange-500/20',
          textColor: 'text-orange-400',
          borderColor: 'border-orange-500/40',
          activeBg: 'bg-orange-500/10',
          note: '💡 Incluye casos reales, simulaciones y actividades prácticas',
          topics: ['Derechos del trabajador', 'Contrato de trabajo', 'Jornada laboral y remuneración', 'Seguridad social', 'Trabajo informal', 'Sindicatos y convenios colectivos', 'Empresa y actividad comercial', 'Sociedades', 'Defensa del consumidor']
        }, {
          title: '📗 TOMO VI – DERECHO PENAL, ADMINISTRATIVO Y DIGITAL',
          icon: <Gavel size={22} data-id="element-69" />,
          bgColor: 'bg-purple-500/20',
          textColor: 'text-purple-400',
          borderColor: 'border-purple-500/40',
          activeBg: 'bg-purple-500/10',
          note: '💡 Incluye análisis de casos actuales y situaciones reales',
          topics: ['Qué es el delito', 'Tipos de delito', 'Responsabilidad penal', 'Sistema penal juvenil', 'Derecho administrativo', 'Acto administrativo', 'Responsabilidad del Estado', 'Derecho digital', 'Protección de datos personales', 'Ciberdelitos', 'Inteligencia artificial y derecho']
        }, {
          title: '💎 ADEMÁS INCLUYE',
          icon: <Star size={22} data-id="element-70" />,
          bgColor: 'bg-green-500/20',
          textColor: 'text-green-400',
          borderColor: 'border-green-500/40',
          activeBg: 'bg-green-500/10',
          note: '',
          topics: ['Actividades listas para usar en cada tema', 'Casos prácticos para trabajar en clase', 'Evaluaciones completas con rúbricas', 'Propuestas de debates', 'Ejercicios de análisis crítico', 'Material organizado para TODO el año']
        }].map((mod, idx) => <ModuleAccordion key={idx} module={mod} data-id="element-71" />)}
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-8 px-4" style={{
      background: 'linear-gradient(180deg, #0f0a2e 0%, #1a1145 100%)'
    }} data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <h2 className="text-3xl sm:text-4xl font-black text-center text-white mb-2" data-id="element-74">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-center text-gray-300 mb-3 max-w-2xl mx-auto" data-id="element-75">
            Para que tengas respaldo profesional y listas de herramientas para
            implementar, incluimos 2 bonos estratégicos:
          </p>

          <div className="flex justify-center mb-4" data-id="element-76">
            <span className="bg-green-500 text-white px-6 py-2 rounded-full text-sm font-black inline-flex items-center gap-2 shadow-lg shadow-green-500/30" data-id="element-77">
              🎁 ¡GRATIS POR EL DÍA DE HOY!
            </span>
          </div>

          {/* Bonus Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" data-id="element-78">
            {/* Bonus 1 */}
            <div className="relative rounded-xl border-2 border-indigo-500/40 p-4 overflow-hidden" style={{
            background: 'rgba(30, 20, 70, 0.8)'
          }} data-id="element-79">
              <span className="absolute top-4 right-4 text-7xl font-black text-white/5 leading-none select-none" data-id="element-80">
                01
              </span>
              <span className="bg-red-600 text-white px-3 py-1 rounded text-xs font-black mb-4 inline-block uppercase tracking-wide" data-id="element-81">
                BONO #01
              </span>
              <h3 className="text-xl font-black text-white mb-3 flex items-center gap-2" data-id="element-82">
                📋 Planificación Anual Derecho Lista
              </h3>
              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-83">
                Organizá todo el año escolar con una planificación clara,
                adaptable y lista para presentar.
              </p>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-white/10" data-id="element-84">
                <span className="text-gray-400 text-sm" data-id="element-85">
                  Valor <span className="line-through" data-id="element-86">$15.000</span>
                </span>
                <span className="bg-green-500 text-white px-4 py-1.5 rounded font-black text-sm shadow-md" data-id="element-87">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="relative rounded-xl border-2 border-indigo-500/40 p-4 overflow-hidden" style={{
            background: 'rgba(30, 20, 70, 0.8)'
          }} data-id="element-88">
              <span className="absolute top-4 right-4 text-7xl font-black text-white/5 leading-none select-none" data-id="element-89">
                02
              </span>
              <span className="bg-red-600 text-white px-3 py-1 rounded text-xs font-black mb-4 inline-block uppercase tracking-wide" data-id="element-90">
                BONO #02
              </span>
              <h3 className="text-xl font-black text-white mb-3 flex items-center gap-2" data-id="element-91">
                🧠 Maletín de Actividades de Derecho
              </h3>
              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-92">
                Mejorá la participación, generá impacto y facilitá clases más
                activas con recursos listos.
              </p>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-white/10" data-id="element-93">
                <span className="text-gray-400 text-sm" data-id="element-94">
                  Valor <span className="line-through" data-id="element-95">$12.000</span>
                </span>
                <span className="bg-green-500 text-white px-4 py-1.5 rounded font-black text-sm shadow-md" data-id="element-96">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          {/* Value Summary */}
          <div className="max-w-md mx-auto bg-gray-900 border border-gray-700 rounded-xl p-4 text-center shadow-xl" data-id="element-97">
            <p className="text-gray-400 text-sm mb-1" data-id="element-98">
              Valor total de los 2 bonus:
            </p>
            <p className="text-red-400 text-2xl font-black line-through mb-2" data-id="element-99">
              $27.000
            </p>
            <p className="text-white font-bold mb-1" data-id="element-100">Hoy te los llevás por:</p>
            <p className="text-green-400 text-5xl font-black mb-2" data-id="element-101">$0</p>
            <p className="text-gray-500 text-sm font-medium" data-id="element-102">
              ✨ Incluidos GRATIS con tu compra de hoy ✨
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY SECTION */}
      <UrgencySection scrollToCheckout={scrollToCheckout} data-id="element-103" />

      {/* OFFER SECTION - PRICING CARDS */}
      <PricingSection mainCheckoutUrl={MAIN_CHECKOUT_URL} upsellCheckoutUrl={UPSELL_CHECKOUT_URL} data-id="element-104" />

      {/* GUARANTEE */}
      <section className="py-8 px-4 bg-black" data-id="element-105">
        <div className="max-w-3xl mx-auto text-center border-2 border-dashed border-green-500/40 p-6 rounded-3xl bg-gray-900" data-id="element-106">
          <Shield className="w-16 h-16 text-green-400 mx-auto mb-3" data-id="element-107" />
          <h2 className="text-3xl font-black text-white mb-2" data-id="element-108">
            GARANTÍA TOTAL
          </h2>
          <p className="text-xl text-gray-300 mb-2" data-id="element-109">Probalo 7 días.</p>
          <p className="text-lg text-gray-400 mb-4" data-id="element-110">
            Si no cumple tus expectativas, te devolvemos el 100%.
          </p>
          <p className="font-black text-green-400 uppercase tracking-widest" data-id="element-111">
            Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-8 px-4 bg-black border-t border-gray-800" data-id="element-112">
        <div className="max-w-6xl mx-auto" data-id="element-113">
          <h2 className="text-3xl font-black text-center text-white mb-5" data-id="element-114">
            TESTIMONIOS DE DOCENTES
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-115">
            {[{
            q: '"Ahora tengo el Derecho organizado por áreas, no improviso más."',
            a: '– María L., Córdoba'
          }, {
            q: '"Los casos reales generan debates increíbles."',
            a: '– Fernando R., Buenos Aires'
          }, {
            q: '"El sistema está claro y profesional."',
            a: '– Carla P., Mendoza'
          }, {
            q: '"Me ahorró semanas de trabajo. El material de penal es excelente."',
            a: '– Roberto S., Santa Fe'
          }, {
            q: '"Mis alumnos por fin se engancharon con la materia. Muy recomendado."',
            a: '– Laura G., Neuquén'
          }].map(({
            q,
            a
          }) => <div key={a} className="bg-gray-900 p-4 rounded-2xl border border-gray-800" data-id="element-116">
                <div className="flex text-yellow-400 mb-4" data-id="element-117">
                  {[1, 2, 3, 4, 5].map(n => <Star key={n} size={16} fill="currentColor" data-id="element-118" />)}
                </div>
                <p className="text-gray-300 italic mb-4 text-base" data-id="element-119">"{q}"</p>
                <p className="font-bold text-white" data-id="element-120">{a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <FAQSection data-id="element-121" />

      {/* FINAL CTA */}
      <section className="py-10 px-4 bg-black text-white text-center border-t border-gray-800" data-id="element-122">
        <div className="max-w-3xl mx-auto" data-id="element-123">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-3" data-id="element-124">
            ¿LISTO/A PARA DEJAR DE IMPROVISAR?
          </h2>
          <p className="text-xl text-gray-400 mb-4" data-id="element-125">
            Sumate a docentes que ya tienen su año resuelto.
          </p>
        </div>

        {/* Inline Compact Pricing */}
        <CompactOfferSection mainCheckoutUrl={MAIN_CHECKOUT_URL} upsellCheckoutUrl={UPSELL_CHECKOUT_URL} data-id="element-126" />
      </section>

      {/* FOOTER */}
      <footer className="py-4 bg-black text-gray-600 text-center text-sm border-t border-gray-900" data-id="element-127">
        <div className="max-w-4xl mx-auto px-4" data-id="element-128">
          <p className="mb-4" data-id="element-129">© 2026 MEGA PACK DERECHO LISTO ™</p>
          <div className="flex justify-center gap-6" data-id="element-130">
            <span className="cursor-pointer hover:text-gray-300 transition-colors" data-id="element-131">
              Términos
            </span>
            <span className="cursor-pointer hover:text-gray-300 transition-colors" data-id="element-132">
              Privacidad
            </span>
            <span className="cursor-pointer hover:text-gray-300 transition-colors" data-id="element-133">
              Soporte
            </span>
          </div>
        </div>
      </footer>
    </div>;
}
function PricingSection({
  mainCheckoutUrl,
  upsellCheckoutUrl
}: {
  mainCheckoutUrl: string;
  upsellCheckoutUrl: string;
}) {
  const [selected, setSelected] = useState(1);
  const packs = [{
    id: 0,
    name: 'Kit Completo',
    subtitle: 'Derecho',
    desc: '6 tomos + Bonus',
    price: '$19.990',
    oldPrice: '$39.990',
    icon: '📚',
    url: mainCheckoutUrl,
    badge: null,
    badgeColor: ''
  }, {
    id: 1,
    name: 'Pack Premium',
    subtitle: 'Kit Completo + Sistema Pro de Evaluación',
    desc: '6 tomos + Bonus',
    price: '$27.990',
    oldPrice: '$49.990',
    icon: '👑',
    url: upsellCheckoutUrl,
    badge: '⭐ Más elegido',
    badgeColor: 'bg-yellow-500 text-black'
  }];
  const currentPack = packs[selected];
  return <section id="oferta" className="py-8 px-4 bg-black border-t border-gray-800" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <h2 className="text-3xl sm:text-4xl font-black text-center text-white mb-6 italic" data-id="element-136">
          Elegí tu Pack Completo
        </h2>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4 max-w-2xl mx-auto" data-id="element-137">
          {packs.map(pack => <button key={pack.id} onClick={() => setSelected(pack.id)} className={`relative rounded-2xl p-5 text-left transition-all duration-300 ${selected === pack.id ? 'bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-green-500 shadow-lg shadow-green-500/10 scale-[1.02]' : 'bg-gray-900 border-2 border-gray-800 hover:border-gray-700'}`} data-id="element-138">
              {/* Badge */}
              {pack.badge && <span className={`absolute -top-3 left-1/2 -translate-x-1/2 ${pack.badgeColor} px-3 py-0.5 rounded-full text-xs font-black whitespace-nowrap`} data-id="element-139">
                  {pack.badge}
                </span>}

              {/* Selection indicator */}
              <div className="absolute top-4 right-4" data-id="element-140">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === pack.id ? 'border-green-500 bg-green-500' : 'border-gray-600'}`} data-id="element-141">
                  {selected === pack.id && <Check size={12} className="text-white" data-id="element-142" />}
                </div>
              </div>

              {/* Icon */}
              <span className="text-3xl mb-3 block" data-id="element-143">{pack.icon}</span>

              {/* Name */}
              <h3 className="text-lg font-black text-white mb-1" data-id="element-144">
                {pack.name}
              </h3>
              <p className="text-xs text-gray-400 mb-1 leading-snug" data-id="element-145">
                {pack.subtitle}
              </p>
              <p className="text-xs text-gray-500 mb-4" data-id="element-146">{pack.desc}</p>

              {/* Price */}
              <p className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-147">
                {pack.price}
              </p>
              <p className="text-sm text-gray-500 line-through" data-id="element-148">
                {pack.oldPrice}
              </p>
            </button>)}
        </div>

        {/* CTA Button */}
        <a href={currentPack.url} className="block w-full max-w-lg mx-auto bg-green-500 hover:bg-green-400 text-white text-lg sm:text-xl font-black py-5 px-8 rounded-xl shadow-[0_4px_0_rgb(22,163,74)] active:shadow-none active:translate-y-1 transition-all text-center mb-4" data-id="element-149">
          SÍ, QUIERO MI PACK →
        </a>

        {/* Secure payment */}
        <p className="text-center text-gray-500 text-sm flex items-center justify-center gap-2" data-id="element-150">
          <Shield size={14} className="text-gray-500" data-id="element-151" />
          PAGO SEGURO CON MERCADO PAGO
        </p>

        {/* How you receive the material */}
        <div className="mt-4 bg-gray-900 border border-gray-800 rounded-xl p-5" data-id="element-152">
          <p className="text-center text-white font-black text-sm mb-4 uppercase tracking-wide" data-id="element-153">
            ¿Cómo recibís el material?
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5" data-id="element-154">
            <div className="flex items-center gap-2" data-id="element-155">
              <span className="bg-green-500 text-white w-7 h-7 rounded-full flex items-center justify-center text-xs font-black shrink-0" data-id="element-156">
                1
              </span>
              <span className="text-gray-300 text-sm font-medium" data-id="element-157">
                Comprás e ingresás tu correo
              </span>
            </div>
            <ArrowRight size={16} className="text-gray-600 hidden sm:block shrink-0" data-id="element-158" />
            <span className="text-gray-600 sm:hidden" data-id="element-159">↓</span>
            <div className="flex items-center gap-2" data-id="element-160">
              <span className="bg-green-500 text-white w-7 h-7 rounded-full flex items-center justify-center text-xs font-black shrink-0" data-id="element-161">
                2
              </span>
              <span className="text-gray-300 text-sm font-medium" data-id="element-162">
                Pago seguro con Mercado Pago
              </span>
            </div>
            <ArrowRight size={16} className="text-gray-600 hidden sm:block shrink-0" data-id="element-163" />
            <span className="text-gray-600 sm:hidden" data-id="element-164">↓</span>
            <div className="flex items-center gap-2" data-id="element-165">
              <span className="bg-green-500 text-white w-7 h-7 rounded-full flex items-center justify-center text-xs font-black shrink-0" data-id="element-166">
                3
              </span>
              <span className="text-gray-300 text-sm font-medium" data-id="element-167">
                Recibís el link de descarga al instante
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function UrgencySection({
  scrollToCheckout
}: {
  scrollToCheckout: () => void;
}) {
  const [timeLeft, setTimeLeft] = useState(1 * 3600 + 11 * 60 + 38);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="py-8 px-4 bg-black text-white text-center" data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black uppercase tracking-wide mb-4" data-id="element-170">
          EL PRECIO DE LANZAMIENTO TERMINA EN
        </h2>

        {/* Countdown */}
        <div className="flex items-center justify-center gap-2 sm:gap-4 mb-3" data-id="element-171">
          <div className="flex flex-col items-center" data-id="element-172">
            <span className="bg-green-600 text-white text-4xl sm:text-5xl font-black px-4 sm:px-6 py-3 rounded-xl shadow-lg shadow-green-600/30 font-mono" data-id="element-173">
              {pad(hours)}
            </span>
            <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest font-bold" data-id="element-174">
              Horas
            </span>
          </div>
          <span className="text-4xl sm:text-5xl font-black text-white/40 -mt-6" data-id="element-175">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-176">
            <span className="bg-red-600 text-white text-4xl sm:text-5xl font-black px-4 sm:px-6 py-3 rounded-xl shadow-lg shadow-red-600/30 font-mono" data-id="element-177">
              {pad(minutes)}
            </span>
            <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest font-bold" data-id="element-178">
              Minutos
            </span>
          </div>
          <span className="text-4xl sm:text-5xl font-black text-white/40 -mt-6" data-id="element-179">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-180">
            <span className="bg-red-600 text-white text-4xl sm:text-5xl font-black px-4 sm:px-6 py-3 rounded-xl shadow-lg shadow-red-600/30 font-mono" data-id="element-181">
              {pad(seconds)}
            </span>
            <span className="text-xs text-gray-400 mt-2 uppercase tracking-widest font-bold" data-id="element-182">
              Segundos
            </span>
          </div>
        </div>

        {/* Urgency Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-4 mt-4" data-id="element-183">
          {[{
          icon: '👥',
          text: 'Últimos cupos disponibles'
        }, {
          icon: '🚀',
          text: 'Oferta de Lanzamiento'
        }, {
          icon: '📈',
          text: 'Precio sube al terminar'
        }].map(badge => <span key={badge.text} className="bg-gray-900 border border-gray-700 text-gray-200 px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2" data-id="element-184">
              {badge.icon} {badge.text}
            </span>)}
        </div>

        {/* Progress Bar */}
        <div className="max-w-md mx-auto mb-4" data-id="element-185">
          <p className="text-sm font-black text-gray-300 mb-2 uppercase tracking-wider" data-id="element-186">
            92% DE CUPOS OCUPADOS
          </p>
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-187">
            <div className="h-full rounded-full bg-gradient-to-r from-red-600 to-red-500 transition-all duration-1000" style={{
            width: '92%'
          }} data-id="element-188" />
          </div>
        </div>

        {/* CTA */}
        <button onClick={scrollToCheckout} className="w-full sm:w-auto bg-green-500 hover:bg-green-400 text-white text-lg sm:text-xl font-black py-5 px-10 rounded-xl shadow-[0_4px_0_rgb(22,163,74)] active:shadow-none active:translate-y-1 transition-all flex items-center justify-center gap-2 mx-auto" data-id="element-189">
          🔒 ASEGURAR MI PRECIO AHORA
        </button>
      </div>
    </section>;
}
function ModuleAccordion({
  module
}: {
  module: {
    title: string;
    icon: React.ReactNode;
    bgColor: string;
    textColor: string;
    borderColor: string;
    activeBg: string;
    topics: string[];
    note?: string;
  };
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`rounded-xl border ${isOpen ? module.borderColor : 'border-gray-800'} overflow-hidden transition-all duration-300 ${isOpen ? 'shadow-lg shadow-black/50' : ''}`} data-id="element-190">
      <button onClick={() => setIsOpen(!isOpen)} className={`w-full flex items-center gap-4 p-5 text-left transition-colors duration-200 ${isOpen ? module.activeBg : 'bg-gray-900 hover:bg-gray-800'}`} data-id="element-191">
        <div className={`${module.bgColor} ${module.textColor} w-11 h-11 rounded-xl flex items-center justify-center shrink-0`} data-id="element-192">
          {module.icon}
        </div>
        <span className="text-lg font-black text-white flex-1" data-id="element-193">
          {module.title}
        </span>
        <ChevronDown size={22} className={`text-gray-500 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-194" />
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-195">
        <ul className="px-5 pb-3 pt-2 space-y-2 bg-gray-900/50" data-id="element-196">
          {module.topics.map(topic => <li key={topic} className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-197">
              <Check size={16} className="mt-0.5 text-green-400 shrink-0" data-id="element-198" />
              {topic}
            </li>)}
        </ul>
        {module.note && <p className="px-5 pb-4 text-yellow-400/90 text-xs font-bold bg-gray-900/50" data-id="element-199">
            {module.note}
          </p>}
      </div>
    </div>;
}
function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos ya tenés todo descargado en tu dispositivo. 100% PDF, sin apps ni plataformas extras.'
  }, {
    q: '¿Sirve para mi provincia o solo para Buenos Aires?',
    a: 'El material está basado en los Núcleos de Aprendizajes Prioritarios (NAP) y contenidos comunes a nivel nacional. Es adaptable a cualquier provincia de Argentina.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material viene en formato PDF listo para usar. Podés imprimirlo, proyectarlo o compartirlo digitalmente con tus alumnos tal cual está.'
  }, {
    q: '¿Los 2 bonos están en todas las ofertas?',
    a: 'Sí, tanto el Kit Completo como el Pack Premium incluyen los 2 bonos exclusivos: la Planificación Anual y el Maletín de Actividades.'
  }, {
    q: '¿Puedo comprar solo el Kit Completo ahora y el Premium después?',
    a: 'Sí, podés empezar con el Kit Completo. Pero el precio del Pack Premium es exclusivo de esta oferta de lanzamiento y no se garantiza después.'
  }, {
    q: '¿Funciona para escuelas con pocos recursos?',
    a: 'Absolutamente. El material es 100% PDF, solo necesitás una impresora o un dispositivo para proyectar. No requiere internet ni plataformas especiales.'
  }, {
    q: '¿Sirve para cursos difíciles o con mucho desorden?',
    a: 'Sí. Las actividades están diseñadas para generar participación activa con casos reales, debates y simulaciones que enganchan incluso a los grupos más complicados.'
  }, {
    q: '¿Está actualizado al currículo vigente?',
    a: 'Sí, todo el contenido está alineado con los diseños curriculares vigentes para Derecho en secundaria argentina.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, tenés 7 días de garantía total. Si no cumple tus expectativas, te devolvemos el 100% del dinero sin preguntas.'
  }, {
    q: '¿Qué diferencia tiene el Kit con otros materiales que vi?',
    a: 'Este es un sistema completo y profesional: no son actividades sueltas. Incluye secuencias didácticas, planificación anual, evaluaciones y actividades prácticas organizadas por área del Derecho.'
  }];
  return <section className="py-8 px-4 border-t border-gray-800" style={{
    background: 'linear-gradient(180deg, #0a0820 0%, #0f0a2e 100%)'
  }} data-id="element-200">
      <div className="max-w-3xl mx-auto" data-id="element-201">
        <h2 className="sm:text-4xl text-center text-white mb-2 flex items-center justify-center gap-3 text-[24px] font-[800]" data-id="element-202">
          <span className="text-red-500 text-4xl" data-id="element-203">❓</span>
          PREGUNTAS <span className="text-green-400 italic" data-id="element-204">FRECUENTES</span>
        </h2>
        <div className="h-1 w-20 mx-auto bg-green-500 rounded-full mb-5" data-id="element-205" />

        <div className="space-y-2" data-id="element-206">
          {faqs.map((faq, i) => <div key={i} className="rounded-lg overflow-hidden border border-gray-700/50" data-id="element-207">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className={`w-full flex items-center gap-3 px-5 py-4 text-left transition-colors duration-200 ${openIndex === i ? 'bg-gray-800/80' : 'bg-gray-900/60 hover:bg-gray-800/40'}`} data-id="element-208">
                <span className="text-green-400 font-black text-sm shrink-0" data-id="element-209">
                  {i + 1} —
                </span>
                <span className="text-white font-bold text-sm flex-1" data-id="element-210">
                  {faq.q}
                </span>
                <ChevronDown size={18} className={`text-gray-500 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-211" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-212">
                <p className="px-5 pb-4 pt-1 text-gray-400 text-sm leading-relaxed pl-14" data-id="element-213">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function CompactOfferSection({
  mainCheckoutUrl,
  upsellCheckoutUrl
}: {
  mainCheckoutUrl: string;
  upsellCheckoutUrl: string;
}) {
  const [selected, setSelected] = useState(1);
  const packs = [{
    id: 0,
    name: 'Kit Completo',
    subtitle: 'Derecho',
    desc: '6 tomos + Bonus',
    price: '$19.990',
    oldPrice: '$39.990',
    icon: '📚',
    url: mainCheckoutUrl,
    badge: null
  }, {
    id: 1,
    name: 'Pack Premium',
    subtitle: 'Kit Completo + Sistema Pro de Evaluación',
    desc: '6 tomos + Bonus',
    price: '$27.990',
    oldPrice: '$49.990',
    icon: '👑',
    url: upsellCheckoutUrl,
    badge: '⭐ Más elegido'
  }];
  const currentPack = packs[selected];
  return <section className="py-4 px-4 bg-black border-t border-gray-800" data-id="element-214">
      <div className="max-w-md mx-auto" data-id="element-215">
        <h2 className="text-xl font-black text-center text-white mb-4 italic" data-id="element-216">
          Elegí tu Pack Completo
        </h2>

        <div className="space-y-2 mb-4" data-id="element-217">
          {packs.map(pack => <button key={pack.id} onClick={() => setSelected(pack.id)} className={`relative w-full rounded-xl p-3.5 text-left transition-all duration-200 ${selected === pack.id ? 'bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-green-500' : 'bg-gray-900 border-2 border-gray-800'}`} data-id="element-218">
              {pack.badge && <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-yellow-500 text-black px-2.5 py-0.5 rounded-full text-[10px] font-black whitespace-nowrap" data-id="element-219">
                  {pack.badge}
                </span>}
              <div className="absolute top-3 right-3" data-id="element-220">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === pack.id ? 'border-green-500 bg-green-500' : 'border-gray-600'}`} data-id="element-221">
                  {selected === pack.id && <Check size={11} className="text-white" data-id="element-222" />}
                </div>
              </div>
              <span className="text-xl mb-1 block leading-none" data-id="element-223">
                {pack.icon}
              </span>
              <h3 className="text-sm font-black text-white" data-id="element-224">{pack.name}</h3>
              <p className="text-[10px] text-gray-400 leading-tight" data-id="element-225">
                {pack.subtitle}
              </p>
              <p className="text-[10px] text-gray-500 mb-2" data-id="element-226">{pack.desc}</p>
              <p className="text-2xl font-black text-white leading-none" data-id="element-227">
                {pack.price}
              </p>
              <p className="text-xs text-gray-500 line-through" data-id="element-228">
                {pack.oldPrice}
              </p>
            </button>)}
        </div>

        <a href={currentPack.url} className="block w-full bg-green-500 hover:bg-green-400 text-white text-base font-black py-3.5 rounded-xl shadow-[0_3px_0_rgb(22,163,74)] active:shadow-none active:translate-y-0.5 transition-all text-center mb-2" data-id="element-229">
          SÍ, QUIERO MI PACK →
        </a>

        <p className="text-center text-gray-500 text-xs flex items-center justify-center gap-1.5" data-id="element-230">
          <Shield size={12} className="text-gray-500" data-id="element-231" />
          PAGO SEGURO CON MERCADO PAGO
        </p>
      </div>
    </section>;
}
function BriefcaseIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-232">
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" data-id="element-233" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-234" />
    </svg>;
}